"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddStudentDropdown = exports.MapStudentsList = exports.RenderStudentItem = exports.getTexts = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var Box_1 = __importDefault(require("@mui/material/Box"));
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var user_config_1 = require("../../configs/user.config");
function getTexts(isEdit, showEventForm) {
    if (isEdit) {
        if (showEventForm) {
            return ['Edit Event', 'Update Event'];
        }
        else {
            return ['Edit Schedule Time Off', 'Update Schedule Time Off'];
        }
    }
    else {
        if (showEventForm) {
            return ['Add an Event', 'Add Event'];
        }
        else {
            return Array(2).fill('Schedule Time Off');
        }
    }
}
exports.getTexts = getTexts;
function RenderStudentItem(_a) {
    var student = _a.student;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.ListItemAvatar, null,
            react_1.default.createElement(material_1.Avatar, null,
                react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: ((student === null || student === void 0 ? void 0 : student.avatar) && user_config_1.userConfig.color[student === null || student === void 0 ? void 0 : student.avatar]) || (student === null || student === void 0 ? void 0 : student.avatar) }))),
        react_1.default.createElement(material_1.ListItemText, { primary: react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.SUBTITLE1 }, student === null || student === void 0 ? void 0 : student.firstName) })));
}
exports.RenderStudentItem = RenderStudentItem;
function MapStudentsList(_a) {
    var selected = _a.selected, studentList = _a.studentList, onRemoveStudent = _a.onRemoveStudent;
    var selectedStudents = selected
        .map(function (id) { return studentList.find(function (s) { return s.guid === id; }); })
        .filter(function (student) { return student === null || student === void 0 ? void 0 : student.guid; });
    return (react_1.default.createElement(react_1.default.Fragment, null, selectedStudents.length > 0 && (react_1.default.createElement(material_1.List, { dense: true }, selectedStudents.map(function (student) { return (react_1.default.createElement(material_1.ListItem, { key: student === null || student === void 0 ? void 0 : student.guid, sx: {
            backgroundColor: 'background.paper',
            borderRadius: 0.5,
            p: 0.5,
        }, secondaryAction: react_1.default.createElement(material_1.IconButton, { edge: "end", "aria-label": "delete", 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onClick: function () { return onRemoveStudent(student.guid); } },
            react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON, size: enums_1.IconSizeEnum.XXSMALL })) }, student && react_1.default.createElement(RenderStudentItem, { student: student }))); })))));
}
exports.MapStudentsList = MapStudentsList;
function AddStudentDropdown(_a) {
    var students = _a.students, onAddStudent = _a.onAddStudent;
    var _b = react_1.default.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var _c = react_1.default.useState([]), selected = _c[0], setSelected = _c[1];
    var handleClickListItem = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function (event, index) {
        setSelected(__spreadArray(__spreadArray([], selected, true), [index], false));
        setAnchorEl(null);
        onAddStudent(index);
    };
    function handleClose() {
        setAnchorEl(null);
    }
    return (react_1.default.createElement(material_1.ClickAwayListener, { onClickAway: handleClose },
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.Chip, { onClick: handleClickListItem, sx: {
                    backgroundColor: 'background.default',
                    borderColor: 'action.disabled',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                }, label: react_1.default.createElement(Box_1.default, { sx: {
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 2,
                        fontWeight: 'normal',
                    } },
                    "Add Student",
                    react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_DOWN, size: enums_1.IconSizeEnum.SMALL })) }),
            students && students.length > 0 && (react_1.default.createElement(material_1.Menu, { key: "students-menu", id: "students-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'students-menu',
                    role: 'liststudents',
                } }, students.map(function (student, idx) {
                var _a, _b;
                return (react_1.default.createElement(material_1.MenuItem, { key: (_a = student.guid) !== null && _a !== void 0 ? _a : idx, selected: selected.includes((_b = student === null || student === void 0 ? void 0 : student.guid) !== null && _b !== void 0 ? _b : 0), onClick: function (event) { var _a; return handleMenuItemClick(event, (_a = student === null || student === void 0 ? void 0 : student.guid) !== null && _a !== void 0 ? _a : 0); } },
                    react_1.default.createElement(RenderStudentItem, { student: student })));
            }))))));
}
exports.AddStudentDropdown = AddStudentDropdown;
